import { render, staticRenderFns } from "./product_settings.vue?vue&type=template&id=36fefd2c&scoped=true&"
import script from "./product_settings.vue?vue&type=script&lang=js&"
export * from "./product_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fefd2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fefd2c')) {
      api.createRecord('36fefd2c', component.options)
    } else {
      api.reload('36fefd2c', component.options)
    }
    module.hot.accept("./product_settings.vue?vue&type=template&id=36fefd2c&scoped=true&", function () {
      api.rerender('36fefd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_settings.vue"
export default component.exports